import { z } from 'zod'

import {
  paymentModelSchema,
  tossClientKeySchema,
  tossCustomerKeySchema,
} from './payment.schema'

const billingOptionSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  method: z.enum(['CARD', 'TOSSPAY', 'NAVERPAY', 'BRANDPAY']),
  available: z.boolean(),
  models: z.array(paymentModelSchema),
})
const billingMethodSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  brand: z.string(),
  last4: z.string().max(4).optional(),
  status: z.enum(['active', 'disabled']),
})
export const billingMethodsSchema = z.object({
  enabled: z.boolean(),
  methods: z.array(billingMethodSchema),
  brandpayEnabled: z.boolean(),
  options: z.array(
    z.object({
      id: z.string().min(1),
      name: z.string().min(1),
      type: z.string().min(1),
      payMethod: z.string().min(1),
      available: z.boolean(),
      models: z.array(paymentModelSchema),
      unavailableReason: z.string().nullable().optional(),
    })
  ),
})
export const brandpaySessionSchema = z.object({
  clientKey: tossClientKeySchema,
  customerKey: tossCustomerKeySchema,
  redirectUrl: z.string().url(),
})
const setupBase = {
  id: z.string().min(1),
  option: billingOptionSchema,
  resultMessage: z.string().optional(),
}
export const billingSetupSchema = z.discriminatedUnion('status', [
  z.object({
    ...setupBase,
    status: z.literal('pending'),
    clientKey: tossClientKeySchema,
    customerKey: tossCustomerKeySchema,
    sandbox: z.boolean(),
    successUrl: z.string().url(),
    failUrl: z.string().url(),
    brandpayRedirectUrl: z.string().url().optional(),
  }),
  z.object({ ...setupBase, status: z.literal('registered') }),
  z.object({ ...setupBase, status: z.literal('failed') }),
])
export const billingAttemptSchema = z.object({
  version: z.literal(1),
  ownerId: z.string().min(1),
  optionId: z.string().min(1),
  consentVersion: z.string().min(1),
  model: paymentModelSchema,
  requestId: z.uuid(),
  setupId: z.string().optional(),
})
export type BillingAttempt = z.infer<typeof billingAttemptSchema>
export type PendingBillingSetup = Extract<
  z.infer<typeof billingSetupSchema>,
  { status: 'pending' }
>
export type BillingMethods = z.infer<typeof billingMethodsSchema>
export type BillingSetup = z.infer<typeof billingSetupSchema>
export type BrandpaySession = z.infer<typeof brandpaySessionSchema>
